import { render, staticRenderFns } from "./VerProfesionales.vue?vue&type=template&id=42e0eb1e&scoped=true&"
import script from "./VerProfesionales.vue?vue&type=script&lang=js&"
export * from "./VerProfesionales.vue?vue&type=script&lang=js&"
import style0 from "./VerProfesionales.vue?vue&type=style&index=0&id=42e0eb1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e0eb1e",
  null
  
)

export default component.exports